import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AlertContentData,
  CategoryType,
} from '@cigna/cigna-for-brokers/shell/data-access';

@Component({
  selector: 'cigna-instant-alert-dialog',
  templateUrl: './instant-alert-dialog.component.html',
  styleUrls: ['./instant-alert-dialog.component.scss'],
})
export class InstantAlertDialogComponent implements OnInit {
  classForCategory: CategoryType[] = [
    { categoryName: 'all', className: 'all' },
    {
      categoryName: 'ma',
      className: 'hand-holding-heart-solid',
    },
    { categoryName: 'pdp', className: 'prescription-bottle-solid' },
    { categoryName: 'csb', className: 'suitcase-medical-solid' },
    { categoryName: 'commercial', className: 'user-group-solid ' },
    { categoryName: 'ifp', className: 'ifp' },
  ];
  alertLength = 125;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<InstantAlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: AlertContentData[],
  ) {}
  ngOnInit() {}

  showReqAccessDialog(): void {
    this.dialog.open(InstantAlertDialogComponent, {
      width: '670px',
    });
  }
  getClass(lob: string) {
    if (lob) {
      const classObj = this.classForCategory.filter(
        (data) => data.categoryName.toLowerCase() === lob.toLowerCase(),
      )[0];
      return classObj?.className;
    }
  }
  onCancel() {
    this.dialogRef.close();
  }
  textLength(data: string) {
    return data.replace(/<[^>]*>?/gm, '').trim().length;
  }
}
